import BarChart from "components/charts/BarChart";
import { barChartDataDailyTraffic } from "variables/charts";
import { barChartOptionsDailyTraffic } from "variables/charts";
import { MdArrowDropUp } from "react-icons/md";
import Card from "components/card";
const DailyTraffic = () => {
  return (
    <Card extra="pb-6 p-5">
      <div className="flex flex-row justify-between items-start mb-4">
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
            Daily Traffic
          </p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-white">
            2.579{" "}
            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
              Visitors
            </span>
          </p>
        </div>
        <div className="flex items-center text-xs text-green-600 bg-green-50 px-2 py-1 rounded-md dark:bg-green-900/20 dark:text-green-400">
          <MdArrowDropUp className="h-4 w-4" />
          <p className="font-semibold"> +2.45% </p>
        </div>
      </div>

      <div className="h-[280px] w-full pt-6 pb-0">
        <BarChart
          chartData={barChartDataDailyTraffic}
          chartOptions={barChartOptionsDailyTraffic}
        />
      </div>
    </Card>
  );
};

export default DailyTraffic;
